const state = require('./state.js');
const DOM = require('./dom.js');
const { qa } = require('../helpers.js');
const { Notyf } = require('notyf');

export const notyf = new Notyf({
    duration: 8000,
    position: { x: 'center', y: 'bottom' },
    dismissible: true,
    ripple: true
});

export const showInfo = (message) => {
    state.infoMessage = message;
    state.showInfo = true;
};

export const hideInfo = () => {
    state.showInfo = false;
};

const breadcrumbs = document.querySelector('#tplBreadcrumbs').firstElementChild.cloneNode(true);
qa('.breadcrumbs').forEach((e, i) => {
    e.appendChild(breadcrumbs.cloneNode(true));
    e.querySelector('.bc-back').addEventListener('click', () => {
        switch (i) {
            case 2:
                state.slide = [1, 0];
                break;
            case 3:
                state.slide = [1, 1];
                break;
            case 4:
                state.slide = [1, 2];
                break;
            case 5:
                state.slide = [2, 0];
                break;
            case 6:
                state.slide = [3, 0];
                break;
            case 7:
                state.slide = [3, 1];
                break;
        }
    });
});

state.bind('slide', (value) => {
    const [main, secondary] = value;

    let extraClasses = [];

    if (DOM.divWrapper.classList.contains('view-loader')) extraClasses.push('view-loader');
    if (DOM.divWrapper.classList.contains('view-bank-rates')) extraClasses.push('view-bank-rates');
    if (DOM.divWrapper.classList.contains('view-pers-rates')) extraClasses.push('view-pers-rates');
    if (DOM.divWrapper.classList.contains('view-overlay-terms')) extraClasses.push('view-overlay-terms');
    if (DOM.divWrapper.classList.contains('view-overlay-content')) extraClasses.push('view-overlay-content');

    DOM.divWrapper.className = `wrapper view-step-${main} ${extraClasses.join(' ')}`;
    if (secondary > 0)
        DOM.divWrapper.classList.add(`view-step-${main}-${secondary + 1}`);


    //NOTE: hacky because of orginal html layout
    switch (main) {
        case 1:
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.add('active'));
            qa('.breadcrumbs li:nth-child(3)').forEach(x => x.classList.remove('active', 'old'));
            qa('.breadcrumbs li:nth-child(4)').forEach(x => x.classList.remove('active', 'old'));
            qa('.breadcrumbs li:nth-child(5)').forEach(x => x.classList.remove('active', 'old'));
            break;
        case 2:
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.add('old'));
            qa('.breadcrumbs li:nth-child(3)').forEach(x => x.classList.add('active'));
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.remove('active'));
            qa('.breadcrumbs li:nth-child(4)').forEach(x => x.classList.remove('active', 'old'));
            qa('.breadcrumbs li:nth-child(5)').forEach(x => x.classList.remove('active', 'old'));
            break;
        case 3:
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.add('old'));
            qa('.breadcrumbs li:nth-child(3)').forEach(x => x.classList.add('old'));
            qa('.breadcrumbs li:nth-child(4)').forEach(x => x.classList.add('active'));
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.remove('active'));
            qa('.breadcrumbs li:nth-child(3)').forEach(x => x.classList.remove('active'));
            qa('.breadcrumbs li:nth-child(5)').forEach(x => x.classList.remove('active', 'old'));
            break;
        case 4:
            qa('.breadcrumbs li:nth-child(4)').forEach(x => x.classList.add('old'));
            qa('.breadcrumbs li:nth-child(5)').forEach(x => x.classList.add('active'));
            qa('.breadcrumbs li:nth-child(2)').forEach(x => x.classList.remove('active'));
            qa('.breadcrumbs li:nth-child(3)').forEach(x => x.classList.remove('active'));
            qa('.breadcrumbs li:nth-child(4)').forEach(x => x.classList.remove('active'));
            break;
    }
});

state.bind('isLoading', (value) => {
    DOM.divWrapper.classList[value ? 'add' : 'remove']('view-loader');
});
state.bind('loaderText', value => {
    DOM.lblLoader.innerText = value;
});

state.bind('showInfo', v => {
    DOM.divWrapper.classList[v ? 'add' : 'remove']('view-info-msg');
});

state.bind('infoMessage', v => {
    DOM.infoDivs.forEach(x => x.querySelector('strong').innerHTML = v);
});

module.exports.state = state;
module.exports.DOM = DOM;